<script>
    export let stroke = "#000000";
</script>

<svg
    viewBox="0 0 320 320"
    width="22px"
    height="22px"
    xmlns="http://www.w3.org/2000/svg"
>
    <g transform="matrix(1, 0, 0, 1, 14, 23)">
        <g
            id="facesocultas"
            transform="matrix(1, 0, 0, 1, -54, -54)"
            style="fill:none;stroke:#c0c0c0;stroke-width:1;stroke-dasharray:12, 4"
        >
            <line
                x1="60"
                y1="260"
                x2="200"
                y2="225"
                id="line7000"
                style="stroke-width: 16px;"
            />
            <line
                x1="340"
                y1="260"
                x2="200"
                y2="225"
                id="line7002"
                style="stroke-width: 16px;"
            />
            <line
                x1="200"
                y1="320"
                x2="200"
                y2="60"
                id="line7004"
                style="stroke-width: 16px;"
            />
        </g>
        <g
            id="faces"
            style="fill:none;stroke:{stroke};stroke-width:3;stroke-linejoin:round"
            transform="matrix(1, 0, 0, 1, 0.000002, 0)"
        >
            <polygon
                points="200,320 340,260 340,80 200,110 200,320 "
                id="polygon7007"
                style="fill-opacity: 0.185185; stroke-width: 16px;"
                transform="translate(-54,-54)"
            />
            <polygon
                points="200,320 60,260 60,80 200,110 200,320 "
                id="polygon7009"
                style="fill-opacity: 0.185185; stroke-width: 16px;"
                transform="translate(-54,-54)"
            />
            <polygon
                points="200,110 60,80 200,60 340,80 200,110 "
                id="polygon7011"
                style="fill-opacity: 0.185185; stroke-width: 16px;"
                transform="translate(-54,-54)"
            />
        </g>
    </g>
</svg>
